/// <amd-module name="NetSuite.LogoList.LogoListCCT.Logo.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("NetSuite.LogoList.LogoListCCT.Logo.View", ["require", "exports", "Backbone", "netsuite_logolist_logo.tpl"], function (require, exports, Backbone_1, netsuite_logolist_logo_tpl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LogoView = /** @class */ (function (_super) {
        __extends(LogoView, _super);
        function LogoView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = netsuite_logolist_logo_tpl;
            _this.target = options.target;
            return _this;
        }
        LogoView.prototype.getContext = function () {
            return {
                image: this.model.get('image'),
                link: this.model.get('link'),
                hasLink: this.model.get('hasLink'),
                alt: this.model.get('alt'),
                title: this.model.get('alt'),
                target: this.target,
                label: this.model.get('label'),
                hasLabel: !!this.model.get('label'),
            };
        };
        return LogoView;
    }(Backbone_1.View));
    exports.LogoView = LogoView;
});
